import { render, staticRenderFns } from "./purchase-end.vue?vue&type=template&id=3fda265e&scoped=true&"
import script from "./purchase-end.vue?vue&type=script&lang=js&"
export * from "./purchase-end.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fda265e",
  null
  
)

export default component.exports